import { useTranslation } from 'react-i18next';

import { useAddresses } from 'contexts/Addresses';
import { DeliveryAddressField } from 'fields';
import { useField } from 'formik';

import type { IDeliveryAddress } from './types';
import { useCallback } from 'react';

export default function DeliveryAddress({ disabled, customerReference }: IDeliveryAddress) {
  const { t } = useTranslation('CreateOrder');

  const [, , { setValue }] = useField('addressData');
  const [{ value: transportMethod }] = useField('transportMethod');

  const {
    state,
    selectors: { selectAddress },
  } = useAddresses();

  const onAddressChange = useCallback(
    async (value: number | string) => {
      const addressData = selectAddress(state, +value);
      if (addressData) {
        await setValue({
          addressNumber: addressData.addressNumber,
          addressName: addressData.addressName,
          addressStreet: addressData.addressStreet,
          postcodeArea: addressData.postcodeArea,
          postcodeDistrict: addressData.postcodeDistrict,
          movementRestriction: addressData.movementRestriction,
        });
      }
    },
    [selectAddress, setValue, state],
  );

  return (
    <DeliveryAddressField
      required
      disabled={disabled}
      name="addressNumber"
      label={t(`ProductForm.labels.deliveryAddress${transportMethod}`)}
      placeholder={t('ProductForm.placeholders.deliveryAddress')}
      noOptionsFoundText={t('ProductForm.labels.noAddressesFound')}
      customerReference={customerReference}
      onChange={onAddressChange}
      transportMethod={transportMethod}
    />
  );
}
